// Amazing Grace (simplified, opening lines) in G major, 3/4. Each chord: [beats, S, A, T, B, lyric].
export const AMAZING_GRACE = {
  title: "Amazing Grace (simplified)",
  time: "3/4",
  bpm: 76,
  chords: [
    [1, "D4", "A3", "F#3", "D3", "A-"],
    [2, "G4", "D4", "B3", "G2", "maz-"], [1, "B4", "D4", "G3", "G2", "ing"],
    [2, "B4", "G4", "D4", "G2", "grace"], [1, "A4", "F#4", "D4", "D3", "how"],
    [2, "G4", "E4", "B3", "E3", "sweet"], [1, "E4", "C4", "G3", "C3", "the"],
    [2, "D4", "B3", "G3", "G2", "sound"], [1, "D4", "A3", "F#3", "D3", "that"],
    [2, "G4", "D4", "B3", "G2", "saved"], [1, "B4", "D4", "G3", "G2", "a"],
    [2, "B4", "D4", "G3", "G2", "wretch"], [1, "A4", "D4", "F#3", "D3", "like"],
    [3, "G4", "D4", "B3", "G2", "me"],
  ],
  bars: [1, 3, 5, 7, 9, 11, 13],
};

export const PARTS = [
  { id: "S", label: "Soprano", idx: 1, clef: "treble", color: "#F472B6" },
  { id: "A", label: "Alto", idx: 2, clef: "treble", color: "#F59E0B" },
  { id: "T", label: "Tenor", idx: 3, clef: "bass", color: "#34D399" },
  { id: "B", label: "Bass", idx: 4, clef: "bass", color: "#60A5FA" },
];
